<template>
  <v-card flat>
    <v-card-text class="text-xs-center">
      <v-container fluid grid-list-md>
        <v-layout wrap v-if="!result">
          <v-flex xs12 sm12 md4 offset-md4>
            <v-text-field v-model="amount"
                          name="amount"
                          :label="label"
                          v-validate="`required|min_value:1|max_value:${maxAmount}`"
                          :error-messages="errors.collect('amount')"
                          data-vv-name="amount"
                          :data-vv-as="$t('attrs.amount')"
                          required
                          persistent-hint
                          :hint="chargeHint"
                          mask="####"
                          prefix="$"
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <v-btn color="primary" @click="generate" :loading="loading">
              {{ $t('generateReference') }}
            </v-btn>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <img src="/openpay_color.png" width="100" alt="">
            <br>
            <img src="/paynet.png" width="120" alt="">
            <br>
            <a :href="termsAndConditions.value" target="_blank" v-if="hasTermsAndConditions"> {{ $t('termsAndConditions') }} </a>
          </v-flex>
        </v-layout>

        <v-layout wrap v-if="result">
          <v-flex xs12 sm12 md4 offset-md4>
            <h2>{{ $t('attrs.reference') }}</h2>
            <p>{{ result.payment_method.reference }}</p>
            <img :src="result.payment_method.barcode_url" alt="" width="200">
            <p>¿Donde pagar? visitanos en: <a href="https://www.openpay.mx/tiendas/" target="_blank">www.openpay.mx/tiendas</a></p>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <v-btn color="primary" :href="pdfLink" target="_blank">
              {{ $t('downloadInstructions') }}
            </v-btn>

            <v-btn color="primary" @click="newReference">
              {{ $t('generateNewReference') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
const COMMISSION_PERCENTAGE = 0.029
const FIXED_AMOUNT = 2.5
const IVA = 1.16
import Openpay from '@/client/openpay'

export default {
  name: 'AddFundsOpenpayStoreComp',

  props: {
    settings: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      loading: false,
      amount: 0,
      result: null
    }
  },

  components: {
  },

  computed: {
    label () {
      const maxAmountFmt = this.$options.filters.currency(this.maxAmount, { precision: 0 })
      return `Monto (Máximo ${maxAmountFmt}  por transacción)`
    },

    maxAmount () {
      const setting = this.settings.find(o => o.key === 'openpay_max_amount')
      if (setting) { return Number(setting.value) }

      return 0
    },

    termsAndConditions () {
      return this.settings.find(o => o.key === 'terms_conditions') || {}
    },

    hasTermsAndConditions () {
      return !!(this.termsAndConditions || {}).value
    },

    dashboardPath () {
      if (process.env.VUE_APP_OPENPAY_ENV === '1') {
        return 'https://sandbox-dashboard.openpay.mx'
      } else {
        return 'https://dashboard.openpay.mx'
      }
    },

    merchantId () {
      const setting = this.settings.find(o => o.key === 'openpay_id')
      if (setting) { return setting.value }

      return ''
    },

    feeAmount () {
      return ((this.amount * COMMISSION_PERCENTAGE) + FIXED_AMOUNT) * IVA
    },

    chargeHint () {
      if (!this.amount) { return '' }

      const amount = Math.round(this.feeAmount * 100) / 100
      return `Al pagar por este medio se te cobra $${amount} de la transacción`
    },

    pdfLink () {
      if (!this.result) { return '' }
      if (!this.result.id) { return '' }

      const ref = this.result.payment_method.reference
      return `${this.dashboardPath}/paynet-pdf/${this.merchantId}/${ref}`
    }
  },

  methods: {
    async generate () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.result = await Openpay.create({
          payment_method: 'store',
          amount: this.amount
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    newReference () {
      this.amount = 0
      this.result = null
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
